import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import SuiTypography from "components/SuiTypography";
import GoalButton from "layouts/goals/components/GoalButton";

function ArchiveHolidayModal({ open, onClose, onConfirm, holidayName, isSubmitting }) {
  return (
    <Dialog open={open} onClose={() => !isSubmitting && onClose()} fullWidth maxWidth="xs">
      <DialogTitle>Archive public holiday?</DialogTitle>
      <DialogContent>
        <SuiTypography variant="button" color="text" display="block">
          Are you sure you want to archive &quot;{holidayName}&quot;? This will remove it from the
          active list.
        </SuiTypography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <GoalButton variant="secondary" onClick={onClose} disabled={isSubmitting}>
          Cancel
        </GoalButton>
        <GoalButton variant="danger" icon="archive" loading={isSubmitting} onClick={onConfirm}>
          Archive
        </GoalButton>
      </DialogActions>
    </Dialog>
  );
}

export default ArchiveHolidayModal;
